import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel } from "@mui/material";
import { Dispatch, FC } from "react";

interface BooleanCellProps {
  disabled?: boolean;
  value: boolean | undefined | null;
  setValue: Dispatch<boolean | undefined>;
  label?: string;
}

export const BooleanCell: FC<BooleanCellProps> = ({ disabled, value, setValue, label }) => {
  const yesValue = value === undefined || value === null ? false : value;
  const noValue = value === undefined || value === null ? false : !value;
  const handleYesClick = () => {
    if (yesValue) setValue(undefined);
    else setValue(true);
  };
  const handleNoClick = () => {
    if (noValue) setValue(undefined);
    else setValue(false);
  };
  return (
    <FormControl component="fieldset" variant="standard">
      {label !== undefined && (
        <FormLabel component="legend" sx={{ fontSize: 9 }}>
          {label}
        </FormLabel>
      )}
      <FormGroup sx={{ display: "flex", flexDirection: "row" }}>
        <FormControlLabel
          label="Yes"
          control={<Checkbox disabled={disabled} color="secondary" checked={yesValue} onChange={handleYesClick} />}
        />
        <FormControlLabel
          label="No"
          control={<Checkbox disabled={disabled} color="secondary" checked={noValue} onChange={handleNoClick} />}
        />
      </FormGroup>
    </FormControl>
  );
};
